import React, { useEffect, useState } from "react";

import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import { logo } from "../../config/Config";


const CustomNavbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [NavOpen , setNavOpen] = useState(false);
  const location = useLocation();



  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      }
      else {
        setScrolled(false)
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll)

    };
    window.scrollTo(0, 0); 

  })

  const handleNavClick = () => {
    setNavOpen(false);
  }


  
  

  return (
    <Navbar expand="xl" variant="dark"
      className={`custom-navbar fixed-top ${scrolled ? "scrolled-navbar" : ""}`}
      expanded={NavOpen}

    >
      <Container>
        <Navbar.Brand href="#home">
          <img src={logo} alt="" className="img-fluid nav-logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav"
        onClick={()=> setNavOpen(!NavOpen)}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {/* <NavDropdown title="About" id="about-dropdown">
              <NavDropdown.Item href="#action/1">Overview</NavDropdown.Item>
              <NavDropdown.Item href="#action/2">Team</NavDropdown.Item>
            </NavDropdown> */}
            <NavLink className="nav-link" to="/"
          onClick={handleNavClick}
            >Home</NavLink>

            <NavLink className="nav-link" to="/about" onClick={handleNavClick} > About</NavLink>
            {/* <NavLink className="nav-link"  to="/" onClick={handleNavClick}>Expertise</NavLink> */}
            <NavLink className="nav-link" to="/contact" onClick={handleNavClick}>Contact </NavLink>

            {/* 
            <NavDropdown title="Ecosystem" id="ecosystem-dropdown">
              <NavDropdown.Item href="#action/3">Partners</NavDropdown.Item>
              <NavDropdown.Item href="#action/4">Developers</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="#developer-hub">
              Developer Hub <span className="new-badge">New</span>
            </Nav.Link>
            <NavDropdown title="Community & News" id="community-dropdown">
              <NavDropdown.Item href="#action/5">Blog</NavDropdown.Item>
              <NavDropdown.Item href="#action/6">Events</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="#mechanics">Mechanics</Nav.Link>
            <Nav.Link href="#testnet">
              Testnet <span className="testnet-indicator"></span>
            </Nav.Link> */}
          </Nav>
          <div className="to-nav-buttons">
            <Link to="/register" className="buy-now">
              Signup
            </Link>
            <Link to="/login" className="buy-now">
              Login
            </Link>
          </div>
        </Navbar.Collapse>
        <div className="nav-buttons">
          <Link to="/login" className="buy-now">
            Login
          </Link>
          <Link to="/register" className="buy-now">
            Sign Up
          </Link>
        </div>

      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
